import { TestSidesTouching } from "../../Pages/GridSnapping";
import { getSelectedListIdFromHtml } from "../utils/editorMainPageUtils";

export const useEditorCanvasTransforms = ({
  editComponentRef,
  editComponent,
  tempLayerScrollbarItems,
  tempLayer,
  tempSelect,
  setSelectedComponent,
  isDragged,
  canvasDimension,
  createFroalaInstance,
  playPauseRef,
  setVerticalLineFor,
  verticalLineFor,
  layerCompData,
  selectedComponent,
  objSides,
  layerSequence,
  getMaxlayerNameCount,
  getHeightestZindex,
  image,
  count,
  setCountZindex,
  isAspectRatioLocked,
  setCount,
  setLayerCompData,
  setScrollbarItems,
  setIsEditorOnScrollbarItems,
  setLayerId,
  setMultiSelectedComps,
  setExpanded,
  setAnimationObject,
  draggerWidth,
}) => {
  const repeatXYUpdate = (temp) => {
    if (editComponentRef.current) {
      return;
    }
    let tempElemLayers = [
      ...(editComponent ? tempLayerScrollbarItems.current : tempLayer.current),
    ];
    if (tempElemLayers.length > 0) {
      let filetredLayer = tempElemLayers.filter((layer) => layer.id === temp.id);
      filetredLayer[0].componentStyles.left = Number(
        parseFloat(+Number(temp.x).toFixed(2)),
      );
      filetredLayer[0].componentStyles.top = Number(
        parseFloat(+Number(temp.y).toFixed(2)),
      );
      filetredLayer[0].componentStyles.right =
        Number(filetredLayer[0].componentStyles.left) +
        Number(filetredLayer[0].componentStyles.width);
      filetredLayer[0].componentStyles.bottom =
        Number(filetredLayer[0].componentStyles.top) +
        filetredLayer[0].componentStyles.height;
      filetredLayer[0].componentStyles.vMiddle = Math.round(
        Number(
          filetredLayer[0].componentStyles.left +
            filetredLayer[0].componentStyles.width / 2,
        ),
      );
      filetredLayer[0].componentStyles.hMiddle = Math.round(
        filetredLayer[0].componentStyles.top +
          filetredLayer[0].componentStyles.height / 2,
      );
      const targetIndex = tempElemLayers.findIndex(
        (selComp) => selComp.id === temp.id,
      );
      if (targetIndex >= 0) {
        tempElemLayers[targetIndex] = filetredLayer[0];
      }
      tempElemLayers[tempElemLayers.length - 1].eachDrag = "yes";
      setSelectedComponent({ ...filetredLayer[0] });
    }
  };

  const updateCompValues = (temp, origin) => {
    isDragged.mouseMove = false;
    isDragged.compDrag = true;
    if (canvasDimension.zoomValue < 60) {
      document.getElementsByTagName("body")[0].style.display = "none";
      // document.getElementsByTagName("body")[0].offsetHeight;
      document.getElementsByTagName("body")[0].style.display = "block";
    }
    if (temp.index !== undefined) {
      if (createFroalaInstance.current.length > 0) {
        if (createFroalaInstance.current[temp.index].hasOwnProperty("editor"))
          createFroalaInstance.current[temp.index].editor.el.blur();
      }
    }
    repeatXYUpdate(temp);
    if (!playPauseRef.current.animationCompleted) return;
    TestSidesTouching(setVerticalLineFor, tempLayer, tempSelect);
  };

  const callOnDragStop = (temp) => {
    isDragged.compDrag = false;

    if (temp.e !== undefined && temp.e.detail !== 2) isDragged.mouseMove = false;
    if (temp.index !== undefined) {
      if (createFroalaInstance.current.length > 0) {
        if (createFroalaInstance.current[temp.index]?.hasOwnProperty("editor"))
          createFroalaInstance.current[temp.index].editor.el.blur();
      }
    }
    let tempElemLayers = [...tempLayer.current];
    if (
      tempElemLayers.length > 0 &&
      temp.id === verticalLineFor.lastSelectedComp?.id
    ) {
      repeatXYUpdate(temp);
      if (!playPauseRef.current.animationCompleted) return;
      TestSidesTouching(setVerticalLineFor, tempLayer, tempSelect);
    }
  };

  const updateFontOnResize = (obj, undoSet) => {
    if (!document.body.classList.contains("cs-canvas-item-resizing")) {
      document.body.classList.add("cs-canvas-item-resizing");
      // Clear after re-resizable handles mouseup (do not clear in capture).
      window.addEventListener(
        "mouseup",
        () =>
          setTimeout(() =>
            document.body.classList.remove("cs-canvas-item-resizing"),
          ),
        { once: true },
      );
    }
    if (layerCompData.length > 0 && obj.id) {
      let tempElemLayers = [...layerCompData];
      let filetredLayer = tempElemLayers.filter((layer) => layer.id === obj.id);
      if (!filetredLayer[0]) return;

      filetredLayer[0].componentStyles.width =
        obj.width || filetredLayer[0].componentStyles.width;

      filetredLayer[0].componentStyles.height =
        obj.height || filetredLayer[0].componentStyles.height;

      filetredLayer[0].componentStyles.left =
        +Number(obj.x).toFixed(2) ||
        Number(filetredLayer[0].componentStyles.left);

      filetredLayer[0].componentStyles.top =
        +Number(obj.y).toFixed(2) ||
        Number(filetredLayer[0].componentStyles.top);
      filetredLayer[0].componentStyles.right =
        Number(filetredLayer[0].componentStyles.left) +
        Number(filetredLayer[0].componentStyles.width);

      filetredLayer[0].componentStyles.bottom =
        Number(filetredLayer[0].componentStyles.top) +
        filetredLayer[0].componentStyles.height;

      filetredLayer[0].componentStyles.vMiddle = Math.round(
        Number(
          filetredLayer[0].componentStyles.left +
            filetredLayer[0].componentStyles.width / 2,
        ),
      );
      filetredLayer[0].componentStyles.hMiddle = Math.round(
        filetredLayer[0].componentStyles.top +
          filetredLayer[0].componentStyles.height / 2,
      );

      // Always write back by resized id (not selectedComponent) to avoid remount.
      const targetIndex = tempElemLayers.findIndex(
        (selComp) => selComp.id === obj.id,
      );
      if (targetIndex < 0) return;
      tempElemLayers[targetIndex] = filetredLayer[0];
      tempElemLayers[tempElemLayers.length - 1].eachDrag = "yes";
      setLayerCompData(tempElemLayers);
      setSelectedComponent({ ...filetredLayer[0] });
      setVerticalLineFor({ ...objSides });
    }
  };

  const callOnResizeStop = (obj, undoSet) => {
    if (layerCompData.length > 0 && obj.id) {
      repeatXYUpdate(obj);
      setVerticalLineFor({ ...objSides });
    }
  };

  const imageOnCanvas = (
    origin,
    url,
    x = 20,
    y = 30,
    filename,
    imag = image,
    width,
    height,
    cnt = count,
    aspectRatio,
  ) => {
    let cntZ = imag.zIndex || getHeightestZindex();
    setCountZindex(cntZ);
    let imagecnt = layerSequence("Image");
    let layerCnt;
    if (imagecnt.length > 0) {
      layerCnt = getMaxlayerNameCount("Image") + 1;
    } else {
      layerCnt = imagecnt.length + 1;
    }
    let Obj = {
      componentType: "Image",
      textComponentType: {
        addContent: "Image",
      },
      moduleIdIdentifier: imag.moduleIdIdentifier,
      id: "Image" + cnt,
      componentId: imag.componentId,
      componentStyles: {
        left: x,
        top: y,

        width: width || imag.width,
        height: height || imag.height,
        bottom: y + (height || imag.height),
        right: (width || imag.width) + x,
        vMiddle: Math.round(x + (width || imag.width) / 2),
        hMiddle: Math.round(y + (height || imag.height) / 2),

        zIndex: cntZ,
        background: url,
        backgroundRepeat: imag.backgroundRepeat,
        filename: filename,
        borderTopLeftRadius: imag.borderTopLeftRadius,
        borderTopRightRadius: imag.borderTopRightRadius,
        borderBottomLeftRadius: imag.borderBottomLeftRadius,
        borderBottomRightRadius: imag.borderBottomRightRadius,
        backgroundSize: imag.backgroundSize,
        border: imag.border,
        repeat: imag.repeat,
        targetLink: imag.targetLink,
        icon: imag.icon,
        backgroundPosition: imag.backgroundPosition,
        BGColor: "#a8d7f9",
        aspectRatio: aspectRatio || imag.aspectRatio,
        aspectLock: isAspectRatioLocked,
        lockBoolean: imag.lockBoolean,
        hideBoolean: imag.hideBoolean,
        opacity: imag.hideBoolean ? 0 : 1,
        compOpacity: imag.compOpacity,
        layerName:
          imag.layerName === "Image" ? imag.layerName + layerCnt : imag.layerName,
        layerNameUpdated:
          imag.layerName === "Image" ? imag.layerName + layerCnt : imag.layerName,
        // New images match other components: span the current timeline.
        // Loaded/pasted assets keep their saved layerWidth.
        layerWidth:
          origin === "fromGetAssets" &&
          Number.isFinite(Number(imag.layerWidth)) &&
          Number(imag.layerWidth) > 0
            ? Number(imag.layerWidth)
            : Number(draggerWidth) > 0
              ? Number(draggerWidth)
              : imag.layerWidth,
        transformOriginX: imag.transformOriginX,
        tranformOriginY: imag.transformOriginY,
        transformOriginZ: imag.transformOriginZ,
        hitAreas: Array.isArray(imag.hitAreas) ? imag.hitAreas : [],
        hitAreaSequence: Math.max(1, Number(imag.hitAreaSequence) || 1),
        ...(Number.isFinite(Number(imag.hitAreaDraggerWidth)) &&
        Number(imag.hitAreaDraggerWidth) > 0
          ? { hitAreaDraggerWidth: Number(imag.hitAreaDraggerWidth) }
          : {}),
      },
      keyFrames: imag.keyFrames || [],
    };
    setCount(count + 1);
    if (origin !== "fromGetAssets" && !editComponent) {
      setLayerCompData([Obj, ...layerCompData]);
      setSelectedComponent(Obj);
    }
    if (editComponent) {
      const scrollbarComp = layerCompData.find(
        (comp) =>
          comp.componentType === "Scrollbar" && comp.id === editComponent?.id,
      );

      if (scrollbarComp) {
        setScrollbarItems([...(scrollbarComp.scrollbarComponents || []), Obj]);
      }
      setLayerCompData((prevData) =>
        prevData.map((comp) =>
          comp.componentType === "Scrollbar" && comp.id === editComponent?.id
            ? {
                ...comp,
                scrollbarComponents: [...(comp.scrollbarComponents || []), Obj],
              }
            : comp,
        ),
      );
      setSelectedComponent(Obj);
      setIsEditorOnScrollbarItems("notClickedYet");
    }

    setLayerId({
      eventDetails: "",
      type: "",
    });
    setMultiSelectedComps([]);

    return Obj;
  };

  const allowDroplayer = (ev) => {
    ev.preventDefault();
  };

  const handleTextChangeInLayerComp = (text, index, type) => {
    let data = [
      ...(editComponent ? tempLayerScrollbarItems.current : tempLayer.current),
    ];
    if (!data[index]) {
      return;
    }
    data[index].froalaText = text;
    if (data[index].componentStyles) {
      const htmlContainer = document.createElement("div");
      htmlContainer.innerHTML = text || "";
      const alignedBlock = htmlContainer.querySelector(
        '[style*="text-align"], .fr-text-left, .fr-text-center, .fr-text-right',
      );
      const inlineAlignment =
        alignedBlock?.style?.textAlign ||
        (alignedBlock?.classList.contains("fr-text-center")
          ? "center"
          : alignedBlock?.classList.contains("fr-text-right")
            ? "right"
            : alignedBlock?.classList.contains("fr-text-left")
              ? "left"
              : null);

      if (inlineAlignment) {
        data[index] = {
          ...data[index],
          componentStyles: {
            ...data[index].componentStyles,
            textAlign: inlineAlignment,
          },
        };
        if (selectedComponent?.id === data[index].id) {
          setSelectedComponent((current) => ({
            ...current,
            froalaText: text,
            componentStyles: {
              ...current.componentStyles,
              textAlign: inlineAlignment,
            },
          }));
        }
      }
    }
    if (data[index].componentStyles) {
      data[index].componentStyles.selectedIdnumberList =
        getSelectedListIdFromHtml(text);
    }
    if (layerCompData[index].componentStyles.expandAndClose) {
      layerCompData[index].componentStyles.expandClose.expandHeight =
        document.getElementById("expandClose" + layerCompData[index].id)
          ?.clientHeight ||
        layerCompData[index].componentStyles.expandClose.expandHeight;
    }
    setLayerCompData(data);
  };

  const handleClickOnCanvas = () => {
    setExpanded({});
  };

  return {
    updateCompValues,
    callOnDragStop,
    updateFontOnResize,
    callOnResizeStop,
    imageOnCanvas,
    allowDroplayer,
    handleTextChangeInLayerComp,
    handleClickOnCanvas,
  };
};
